<template>
    <div>
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
                <v-btn v-if="showButton" v-on="on" id="novoRegistro" fab small dark color="#10303D" slot="activator" @click="emit('initComponent')">
                <v-icon small>fas fa-plus</v-icon>
            </v-btn>
            </template>
            <span>{{tooltip}}</span>
        </v-tooltip>
        
        <v-dialog :persistent="persistent" v-model="dialog" :width="size">
            <v-card raised style="border-top: solid; border-top-color: #10303D; border-top-width: 3px;">
                <v-toolbar flat>
                    <v-toolbar-title >{{ tituloTela }}</v-toolbar-title>
                </v-toolbar>

                <v-card-text pa-0 ma-0>
                    <slot/>
                </v-card-text>
                
                <v-layout ma-0 pa-2 pr-5 pl-5 >
                    <v-layout row wrap justify-start>
                        <v-btn id="cancel" rounded @click="emit('cancel')" style="background-color:#e8e8e8;"> 
                            <span  class="marginSpan"> {{textButtonFechar}} </span>
                            <v-icon small>fa-times</v-icon>
                        </v-btn>
                    </v-layout>
                    <v-layout row wrap justify-end>
                        <v-btn v-if="canDelete" id="deleteRegistro" dark rounded color="red" @click="emit('deleteRegistro')" class="mr-2">
                            <span class="marginSpan"> Deletar </span>
                            <v-icon dark small>fas fa-trash-alt</v-icon>
                        </v-btn>
                        <v-btn v-if="canSave" id="saveRegistro" dark rounded color="primary" @click="emit('saveRegistro')">
                            <span class="marginSpan"> {{textButtonSalvar}} </span>
                            <v-icon dark small>fa-save</v-icon>
                        </v-btn>
                    </v-layout>
                </v-layout>
            </v-card>
            <AppLoaderBlockCard :overlay="isLoading"/>
        </v-dialog>
    </div>
</template>

<script>

import AppLoaderBlockCard from '@/components/layout/AppLoaderBlockCard.vue'

export default {
    components: {
        AppLoaderBlockCard
    },
    methods: {
        emit(event) {
            this.$emit(event)
        }
    },
    model: {
        prop: 'value',
        event: 'input'
    },
    computed: {
        dialog: {
            get() {
                return this.value
            },
            set(val)
            {
                this.$emit('input', val)
            }
        },
    },
    props: {
        value: Boolean,
        isLoading: Boolean,
        tooltip: String,
        tituloTela: String,
        size: {
            type: String,
            default: "500"
        },
        showButton: {
            type: Boolean,
            default: true
        },
        canDelete: {
            type: Boolean,
            default: false
        },
        canSave: {
            type: Boolean,
            default: true
        },
        textButtonFechar: {
            type: String,
            default: "cancelar"
        },
        textButtonSalvar: {
            type: String,
            default: "salvar"
        },
        persistent: {
            type: Boolean,
            default: true
        },
    }
}
</script>

<style scoped>
    .item-select-dialog {
        margin: 2%;
        height: 30px;
        width: 30px;
        vertical-align: middle;
    }
    .marginSpan {
        margin: 5px
    }
</style>